var map = {
	"./Auth/ConfirmPassword": 5181,
	"./Auth/ConfirmPassword.js": 5181,
	"./Auth/ForgotPassword": 5544,
	"./Auth/ForgotPassword.js": 5544,
	"./Auth/Login": 3254,
	"./Auth/Login.js": 3254,
	"./Auth/Register": 605,
	"./Auth/Register.js": 605,
	"./Auth/ResetPassword": 6152,
	"./Auth/ResetPassword.js": 6152,
	"./Auth/VerifyEmail": 8372,
	"./Auth/VerifyEmail.js": 8372,
	"./Dashboard": 3300,
	"./Dashboard.js": 3300,
	"./Index": 317,
	"./Index.js": 317,
	"./Publications/Create": 8985,
	"./Publications/Create.js": 8985,
	"./Publications/Edit": 3675,
	"./Publications/Edit.js": 3675,
	"./Publications/Index": 374,
	"./Publications/Index.js": 374,
	"./ServicesAvailable": 3377,
	"./ServicesAvailable.js": 3377,
	"./ServicesDataScience": 6187,
	"./ServicesDataScience.js": 6187,
	"./ServicesDatabase": 3750,
	"./ServicesDatabase.js": 3750,
	"./ServicesDesign": 7494,
	"./ServicesDesign.js": 7494,
	"./ServicesGeneration": 81,
	"./ServicesGeneration.js": 81,
	"./ServicesMeta": 6498,
	"./ServicesMeta.js": 6498,
	"./ServicesRegistry": 6328,
	"./ServicesRegistry.js": 6328,
	"./ServicesRevision": 2909,
	"./ServicesRevision.js": 2909,
	"./Welcome": 9033,
	"./Welcome.js": 9033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;